<template>
  <v-toolbar dark app class="indigo">
    <v-img
      class="link"
      @click="goHome"
      max-width="100"
      max-height="56"
      src="https://levelupgroup.nl/wp-content/uploads/2018/03/Level-Up-Group-white.png"
    ></v-img>

    <v-toolbar-title @click="goHome" class="link headline text-uppercase">
      <span class="font-weight-bold">GA</span>
      <span class="font-weight-light">MANAGEMENT</span>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <toolbar-account></toolbar-account>
  </v-toolbar>
</template>

<script>
import ToolbarAccount from "@/components/ToolbarAccount";

export default {
  name: "Toolbar",
  components: {
    ToolbarAccount
  },
  methods: {
    goHome() {
      this.$router.push({ path: "/" });
    }
  }
};
</script>

<style>
.link {
  cursor: pointer;
}
</style>
